import styles from './SubprojectShow.module.less';
import { ContentTitle, Subtitle } from '../../../components/typography/Heading';
import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import { useEffect, useMemo, useState } from 'react';
import Storage from '../../../utils/storage';
import { useProject } from '../../project-hooks/useProject';
import { useSubproject } from '../../../components/hooks/useSubproject';
import { useUser } from '../../../user/useUser';
import { fetchPrivateSubproject, updateSubprojectOwner } from '../../subproject/subproject-actions';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router';
import LoginOrRegisterModal from '../../../user/login-and-register-modal/LoginOrRegisterModal';

export const SubprojectInvitedHeader = ({ showShare, showQr }) => {
    const [showLoginModal, setShowLoginModal] = useState(false);
    const project = useProject();
    const dispatch = useDispatch();
    const { subproject } = useSubproject();
    const user = useUser();
    const location = useLocation();
    const navigate = useNavigate();

    const storage = new Storage('sessionStorage');
    const acceptedInvitationSessionItem = storage.get('acceptedInvitation');
    const hasUserAcceptedInvitation = useMemo(() => {
        if (!acceptedInvitationSessionItem) {
            return false;
        }
        const [projectId, subProjectId] = acceptedInvitationSessionItem.split('-');
        return project?.id === parseInt(projectId, 10) && subproject?.id === parseInt(subProjectId, 10);
    }, [acceptedInvitationSessionItem, project?.id, subproject?.id]);

    useEffect(() => {
        if (subproject?.id && user?.id && user?.id !== subproject?.user_id && hasUserAcceptedInvitation) {
            dispatch(
                updateSubprojectOwner({
                    subprojectId: subproject.id,
                    uuid: storage.get('invitationToken'),
                })
            )
                .then(() => dispatch(fetchPrivateSubproject({ subprojectId: subproject.id, projectId: project.id })))
                .then(() => navigate(`/project/${project.id}/subproject/${subproject.id}/edit`));
        }
    }, [user?.id, subproject?.user_id, hasUserAcceptedInvitation]);

    if (!hasUserAcceptedInvitation || user?.id) {
        return null;
    }
    return (
        <div className={styles.ownerWrapper}>
            <LoginOrRegisterModal
                isOpen={showLoginModal}
                title={'Logg inn/Registrer deg'}
                onClose={() => setShowLoginModal(false)}
                redirectLink={location.pathname + location.search}
            >
                <p>
                    For å endre navnet og bildet til deltakeren må du logge inn på din personlige bruker eller
                    registrere deg
                </p>
            </LoginOrRegisterModal>
            <ContentTitle className={styles.ownerTitle}>Din salgsside</ContentTitle>
            <div className={styles.ownerButtons}>
                <RoundedButtonPrimary
                    trackingCategory={'subproject-admin-share'}
                    trackingAction={'click'}
                    trackingParameters={{ invited: true }}
                    onClick={showShare}
                >
                    Del salgssiden
                </RoundedButtonPrimary>
                <RoundedButtonSecondary
                    trackingCategory={'subproject-admin-qr'}
                    trackingAction={'click'}
                    trackingParameters={{
                        'subproject-id': subproject.id,
                        'project-id': project.id,
                        everyone: false,
                        invited: true,
                    }}
                    onClick={showQr}
                    className={styles.shareQrButton}
                >
                    <i className={'fa-regular fa-qrcode'} /> Vis QR-kode
                </RoundedButtonSecondary>
                <RoundedButtonSecondary
                    trackingCategory={'subproject-register'}
                    trackingAction={'click'}
                    trackingParameters={{
                        'subproject-id': subproject.id,
                        'project-id': project.id,
                        invited: true,
                    }}
                    onClick={() => setShowLoginModal(true)}
                >
                    <i className={'fa-regular fa-pen-to-square'} /> Endre navn og bilde
                </RoundedButtonSecondary>
            </div>
            <Subtitle className={styles.ownerSubtitle}>Slik ser salgssiden din ut 👇</Subtitle>
        </div>
    );
};
